import queryString from 'query-string';
import { get, del, post } from './apiUtils';

const defaultUrl = '/SubstancesCosAnnexes/';

export default {
  getSubstanceCosAnnexes: ({ id, query } = {}) =>
    get(`${defaultUrl}${id || ''}${query ? '?'.concat(queryString.stringify(query)) : ''}`),
  deleteSubstanceCosAnnexe: id => del(`${defaultUrl}${id}`),
  saveSubstanceCosAnnexe: data => post(`${defaultUrl}`, data),
};
